<template>
    <div class="group-member">
        <head-image :id="member.userId" :name="member.showNickName" :url="member.headImage" :size="38"
            :online="member.online" :is-show-user-info="canShowUserInfo">
        </head-image>
        <el-tag v-if="member.userId == ownerId" class="role-tag" size="mini" type="danger" effect="dark">群主</el-tag>
        <el-tag v-else-if="member.isManager" class="role-tag" size="mini" type="warning" effect="dark">管理</el-tag>
        <div class="member-name">{{ member.friendRemark || member.showNickName }}</div>
    </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
export default {
    name: "groupMember",
    components: { HeadImage },
    data() {
        return {};
    },
    props: {
        member: {
            type: Object,
            required: true
        },
        ownerId: {
            type: Number
        },
        disablePrivateChat: {
            type: Boolean,
            default: false
        },
        canManage: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        canShowUserInfo() {
            // 禁止私聊时，普通成员不能查看他人资料
            return this.canManage || !this.disablePrivateChat;
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.group-member {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50px;
    position: relative;

    .role-tag {
        position: absolute;
        top: -4px;
        right: -6px;
    }

    .member-name {
        font-size: 12px;
        text-align: center;
        width: 100%;
        height: 30px;
        line-height: 30px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden
    }
}
</style>
